import api from './api';

/** A traceable carrier for the "Trace Container" dropdown, with the legacy
 *  trace side it maps to (rail = terminal/rail, scac = SSLine). The side lets
 *  the ➡️ force the right tracer when the picked carrier differs from the
 *  order's saved one. */
export interface TraceCarrier {
  carrier: string;
  type: 'rail' | 'scac';
}

/**
 * Traceable carriers for the Pro Detail "Trace Container" dropdown.
 *
 * The list is the union of active/dotrace SCAC profiles and non-deleted
 * dotrace rails (V1 buildtraceunits query) — a few dozen effectively-static
 * codes, so we cache the response in module scope to avoid duplicate fetches
 * across pro-detail mounts, exactly like getRails / getCstDispatchers.
 */
let cache: Promise<TraceCarrier[]> | null = null;

export async function getTraceCarriers(): Promise<TraceCarrier[]> {
  if (!cache) {
    cache = api
      .get<TraceCarrier[]>('/admin/trace-carriers')
      .then((r) => r.data)
      .catch((err) => {
        // Reset on failure so a retry isn't permanently poisoned.
        cache = null;
        throw err;
      });
  }
  return cache;
}

/** Drops the in-memory cache. Mostly useful for tests. */
export function clearTraceCarriersCache(): void {
  cache = null;
}
